/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import MenuItem from "@mui/material/MenuItem";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import LogoutIcon from "@mui/icons-material/Logout";
import { styled } from "@mui/material/styles";
import MenuList from "@mui/material/MenuList";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../contexts/useStorageContext";
import { actionTypes } from "../../../types/state";
import { IUser, IUserPublicProfile } from "../../../types/user";
import { NotificationIconButton } from "./NotificationIconButton";
import UserFormDialog from "../../pages/users/UserFormDialog";
import UserAvatar from "../User/UserAvatar";

const Navbar = styled(AppBar, {
  shouldForwardProp: (prop: string) => prop !== "openSideMenu",
})<{
  openSideMenu?: boolean;
  drawerwidth?: number;
}>(({ theme, openSideMenu, drawerwidth }) => ({
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // marginLeft: `-${drawerWidth}px`,
  marginLeft: "0px",
  width: "100%",
  ...(openSideMenu && {
    width: `calc(100% - ${drawerwidth}px)`,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // marginLeft: 0,
    marginLeft: `${drawerwidth}px`,
  }),
}));

export default function NavBar({ drawerWidth }: { drawerWidth?: number }) {
  const { dispatch, state } = useAppContext();
  const navigation = useNavigate();
  const { openSideDrawer, loggedInUserInfo, myCompanyProfile } = state;
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const [openUserFormDialog, setOpenUserFormDialog] = React.useState(false);
  const [lastChemSsid, setLastChemSsid] = React.useState<number>(0);
  const [lastSpecSsid, setLastSpecSsid] = React.useState<number>(0);
  const [loadingLastSsids, setLoadingLastSsids] = React.useState(false);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Navbar
      openSideMenu={openSideDrawer}
      drawerwidth={drawerWidth == undefined ? 270 : drawerWidth}
      position="fixed"
      elevation={1}
      sx={{
        bgcolor: "navbar.default",
        borderBottom: "solid 1px #e5e5e5",
        flex: "unset",
        zIndex: 1,
      }}
    >
      <Box>
        <Box sx={{ px: { xs: 0, sm: 2 } }}>
          <Toolbar disableGutters sx={{ minHeight: { xl: "72px" } }}>
            <IconButton
              onClick={() =>
                dispatch!({
                  type: actionTypes.setOpenSideDrawer,
                  value: !openSideDrawer,
                })
              }
              className="sm:mr-3"
            >
              <MenuIcon
                sx={{
                  color: "button.black",
                  fontSize: { xs: "30px", lg: "35px" },
                }}
              />
            </IconButton>

            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <img
                src="/nestle-logo.svg"
                alt="Nestle Sample Feeder Logo"
                style={{ maxHeight: "38px", minHeight: "38px" }}
              />
              {/* <Box
                sx={{
                  color: "secondary.main",
                  ml: "12px",
                  fontSize: "24px",
                  mb: "-2.5px",
                  fontFamily: "cursive",
                }}
              >
                Sample Feeders
              </Box> */}
            </Box>

            <Box
              sx={{
                px: { xs: 0, sm: 1 },
                flexGrow: 1,
                alignItems: "center",
                justifyContent: "flex-end",
                display: { xs: "flex" },
              }}
            >
              {/* <CompanyAutoComplete
                value={selectedCompany}
                onChange={(selected) =>
                  setSelectedCompany(selected || undefined)
                }
              /> */}
              {/* <Box
                sx={{
                  color: "#888",
                  fontSize: "12px",
                  marginRight: "20px",
                  borderLeft: "solid 2px #dedede",
                  paddingLeft: "6px",
                  display: { xs: "none", sm: "block" },
                  ml: 1,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>Last Chem SSID: </div>
                  {loadingLastSsids ? (
                    <CircularProgress size={12} sx={{ ml: 1 }} />
                  ) : (
                    <Box sx={{ color: "warning.main", ml: "5px" }}>
                      {lastChemSsid || "?"}
                    </Box>
                  )}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>Last Spectra SSID: </div>
                  {loadingLastSsids ? (
                    <CircularProgress size={12} sx={{ ml: 1 }} />
                  ) : (
                    <Box sx={{ color: "warning.main", ml: "5px" }}>
                      {lastSpecSsid || "?"}
                    </Box>
                  )}
                </div>
              </Box> */}
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <NotificationIconButton />
              <IconButton onClick={handleOpenUserMenu}>
                <PermIdentityIcon
                  sx={{
                    color: "button.black",
                    fontSize: { xs: "30px", lg: "35px" },
                  }}
                />
              </IconButton>

              <Popover
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <Box sx={{ minWidth: 250 }}>
                  {/* <Box
                    sx={{
                      color: "#888",
                      background: "#f1f1f1",
                      fontSize: "12px",
                      paddingLeft: "6px",
                      p: 2,
                      pb: 1,
                      display: { xs: "block", sm: "none" },
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div>Last Chem SSID: </div>
                      {loadingLastSsids ? (
                        <CircularProgress size={12} sx={{ ml: 1 }} />
                      ) : (
                        <Box sx={{ color: "warning.main", ml: "5px" }}>
                          {lastChemSsid || "N/A"}
                        </Box>
                      )}
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div>Last Spectra SSID: </div>
                      {loadingLastSsids ? (
                        <CircularProgress size={12} sx={{ ml: 1 }} />
                      ) : (
                        <Box sx={{ color: "warning.main", ml: "5px" }}>
                          {lastSpecSsid || "N/A"}
                        </Box>
                      )}
                    </div>
                  </Box> */}
                  <Box p={2} sx={{ display: "flex", alignItems: "center" }}>
                    <UserAvatar
                      user={loggedInUserInfo as IUserPublicProfile}
                      sx={{ width: "35px", height: "35px" }}
                    />
                    <Box sx={{ flex: 1, ml: 1 }}>
                      <Typography variant="h6">
                        {loggedInUserInfo?.fullname}
                      </Typography>
                      <Typography variant="body2">
                        {loggedInUserInfo?.email}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider />
                  <Box>
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          setOpenUserFormDialog(true);
                        }}
                      >
                        <ListItemIcon>
                          <EditIcon />
                        </ListItemIcon>
                        <ListItemText>Edit Profile</ListItemText>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          dispatch!({
                            type: actionTypes.setLoggedInUserInfo,
                            value: undefined,
                          });
                          navigation("/");
                        }}
                      >
                        <ListItemIcon>
                          <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText>Log out</ListItemText>
                      </MenuItem>
                    </MenuList>
                  </Box>
                </Box>
              </Popover>
            </Box>
          </Toolbar>
        </Box>
      </Box>
      {openUserFormDialog && (
        <UserFormDialog
          open
          user={{ ...loggedInUserInfo, company: myCompanyProfile } as IUser}
          onClose={() => setOpenUserFormDialog(false)}
          onUpdated={(updatedUser) => {
            dispatch!({
              type: actionTypes.setLoggedInUserInfo,
              value: { ...(loggedInUserInfo || {}), ...updatedUser },
            });
            setOpenUserFormDialog(false);
          }}
        />
      )}
    </Navbar>
  );
}
